<template>
  <div class="select-message">
    <button
      v-if="maximumNumberOfSelectableElements >= checkboxes.length"
      type="button"
      class="select-all-button"
      @click="clickSelectAll">
      <strong>{{ selectAllTitle }}</strong>
    </button>
    <form class="select-message-form">
      <div class="select-message-form-checkboxes">
        <label
          v-for="(checkbox, index) in checkboxes"
          :key="index"
          class="cc-checkbox-container"
          :class="{disabled: disabled(checkbox)}"
          :for="`checkbox${index}`">
          {{ checkbox.title }}
          <input :id="`checkbox${index}`"
                 v-model="selectedUUIDs"
                 type="checkbox"
                 :name="`checkbox${index}`"
                 :value="checkbox.uuid"
                 :disabled="disabled(checkbox)"
                 @click="removeNoneFromSelectedValues">
          <span class="checkmark" />
        </label>
        <label
          v-if="isNoneOptionEnabled"
          key="none"
          class="cc-checkbox-container"
          for="checkbox-none">
          {{ selectNoneOptionTitle }}
          <input id="checkbox-none"
                 v-model="selectedUUIDs"
                 type="checkbox"
                 name="checkbox-none"
                 :value="null"
                 :disabled="isNoneSelected"
                 @click="selectNone">
          <span class="checkmark" />
        </label>
      </div>
      <button type="button"
              class="quick-reply-button"
              :disabled="selectedUUIDs.length === 0"
              @click="submitCheckboxes">
        {{ message.content.title }}
      </button>
    </form>
  </div>
</template>

<script>
// @flow

import type { MultipleChoiceValue } from '@chatchamp/chatchamp-types'

import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../../../main/eventTracking'
import { sendCheckboxes } from '../../../utils/api'

export default {
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => {
    return {
      selectedUUIDs: [],
      isNoneSelected: false
    }
  },
  computed: {
    checkboxes (): Array<MultipleChoiceValue> {
      return this.message.content?.checkboxes || []
    },
    maximumNumberOfSelectableElements (): number {
      return this.message.content.select?.maximumNumberOfSelectableElements || 99
    },
    isNoneOptionEnabled () {
      return this.message.content?.selectNoneOptionEnabled
    },
    noneCheckbox (): MultipleChoiceValue {
      return {
        title: this.selectNoneOptionTitle,
        uuid: '',
        value: ''
      }
    },
    selectAllTitle () {
      return this.message.content.selectAllTitle || this.$t('chatbot.selectAll')
    },
    selectNoneOptionTitle () {
      return this.message.content.selectNoneOptionTitle || this.$t('chatbot.none')
    },
    selectedCheckBoxes (): Array<MultipleChoiceValue> {
      const selectedCheckboxes = this.checkboxes.filter(cb => this.selectedUUIDs.includes(cb.uuid))
      if (selectedCheckboxes.length === 0) selectedCheckboxes.push(this.noneCheckbox)
      return selectedCheckboxes
    }
  },
  methods: {
    disabled (checkbox: any): boolean {
      return !this.isNoneSelected &&
        this.selectedUUIDs.length >= this.maximumNumberOfSelectableElements &&
        this.selectedUUIDs.indexOf(checkbox.uuid) === -1
    },
    async submitCheckboxes () {
      const { attribute } = this.message.content
      const text = this.selectedCheckBoxes.map(cb => cb.title).join(', ')
      const value = this.selectedCheckBoxes.map(cb => cb.value).join(',')
      await sendCheckboxes(this.selectedCheckBoxes, this.message.content.messageId)
      await this.$store.dispatch('addTextMessageToList', text)
      if (attribute) dispatchChatchampEvent(CHATBOT_EVENTS.AttributeSet, { ...attribute, value })
    },
    clickSelectAll () {
      this.removeNoneFromSelectedValues()
      this.selectedUUIDs = this.checkboxes.map(checkbox => checkbox.uuid)
    },
    selectNone () {
      this.selectedUUIDs = []
      this.isNoneSelected = true
    },
    removeNoneFromSelectedValues () {
      this.selectedUUIDs = this.selectedUUIDs.filter(uuid => uuid !== null)
      this.isNoneSelected = false
    }
  }
}
</script>

<style src="./select-message.scss" />
